/**
 * What is actually on sale.
 *
 * The product deliberately narrowed to three tier-one cities to test demand
 * before expanding. The catalog still holds all 109 experiences — nothing was
 * deleted — but only these cities are offered. Reopening a city is a one-line
 * change here, and the guide data and media for the rest are still in the repo.
 */
import { CATALOG } from "./catalog.data.js";
import { SIDEKICKS } from "./sidekicks.js";
import type { Experience, Sidekick } from "./types.js";

export const ACTIVE_CITIES = ["上海", "北京", "深圳"] as const;
export type ActiveCity = (typeof ACTIVE_CITIES)[number];

export const isActiveCity = (city: string): city is ActiveCity =>
  (ACTIVE_CITIES as readonly string[]).includes(city);

/** The only experiences the product will plan, price or show. */
export const ACTIVE_CATALOG: Experience[] = CATALOG.filter((c) => isActiveCity(c.city));

export const CITY_LABEL: Record<ActiveCity, { en: string; cn: string }> = {
  上海: { en: "Shanghai", cn: "上海" },
  北京: { en: "Beijing", cn: "北京" },
  深圳: { en: "Shenzhen", cn: "深圳" },
};

/**
 * Sidekicks in cities we currently sell. Yuqi (Chengdu) and Mei Lin (Guilin)
 * are kept in the data but inactive — they come back with their cities.
 */
export const ACTIVE_SIDEKICKS: Sidekick[] = SIDEKICKS.filter((s) => isActiveCity(s.city));
